import React, { useState, useEffect, Fragment } from 'react'

import './content-header-articles-mg.scss'
import ArticleFloatMenu from '../article-float-menu/article-float-menu';

const ContentHeaderArticlesMG = props => {

    const [activeCategorySlug, setCategorySlug] = useState('');
    const [activeCategoryTitle, setCategoryTitle] = useState('');
    const [pageLoad, setPageLoad] = useState(false);

    useEffect(() => {
        setPageLoad(true);

        if (typeof window !== `undefined`) {
            setCategorySlug(sessionStorage.getItem("slugFilterMagazin"));
            setCategoryTitle(sessionStorage.getItem("titleFilterMagazin"));
            return
        }else{
            setCategorySlug('lo-ultimo');
            setCategoryTitle('Lo Último');
            return
        }
    })
    
    var imgMobile = props.infoArticle.bannerArticulo[1]
    var imgPc = props.infoArticle.bannerArticulo[0]
    var siteTitle = props.sitioPadre.replace(/-/g,' ');
    var articleCategories = props.infoArticle.categorias;
    var articleTitle = props.infoArticle.title;

    return (
        <div className="f-header-articles-container">


            <div className="f-header-articles-content-section">
                <img className="f-banner-main-article"
                    src={pageLoad ? props.mobile ? imgMobile.file.url : imgPc.file.url : props.mobile ? imgMobile.fixed.base64 : imgPc.fixed.base64}
                    alt={imgPc.description}
                    height={props.mobile ? imgMobile.file.details.image.height : imgPc.file.details.image.height}
                />
                <div className="f-titles-header-container">

                    <h2 className="f-site-title">{siteTitle}</h2>

                    {articleCategories.map((categoria,index) =>{

                        if(index === 0){
                            return (
                                <Fragment key={index}>
                                    {activeCategorySlug === 'lo-ultimo' ? <span className="f-category-article-title" key={index}>{categoria.titulo}</span> : null}
                                </Fragment>
                            )
                        }else{
                            return null
                        }
                    })}

                    {activeCategorySlug !== 'lo-ultimo' ? <span className="f-category-article-title">{activeCategoryTitle}</span> : null}

                    {!props.mobile ? <h1 className="f-article-title">{articleTitle}</h1> : null}

                </div>

            </div>

            {!props.mobile && props.infoArticle.autopauta[0] !== null ?
                <div className="f-autopauta-position">
                    <ArticleFloatMenu 
                        infoArticle={props.infoArticle}
                        slugPrefix={'/magazin/nuestro-mundo/'}
                    />
                </div>
                :
                null
            }

        </div>
    )
}

export default ContentHeaderArticlesMG
